import { Dialog } from "primereact/dialog";
import { TabPanel, TabView } from 'primereact/tabview';
import { Toast } from "primereact/toast";
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { getI18nLanguageFromLocalStorage } from '../../helpers/localStorageHelper';
import { translate } from '../../localization/translateService';
import { getTrainerDetail } from '../../services/trainersService';
import AvailabilityTable from '../AvailabilityTable';
import TrainerRating from '../TrainerRating';
import TrainerDetailInformation from './TrainerDetailInformation';
import TrainerDetailProfile from './TrainerDetailProfile';
import { SuccessTemplate } from "../common/ToastMessage/Template";

const TrainerDetailModal = forwardRef(({
  defaultAvatar
}, ref) => {
  const [visible, setVisible] = useState(false);
  const [trainerId, setTrainerId] = useState(null);
  const [trainer, setTrainer] = useState({});
  const [lang, setLanguage] = useState("");
  const [activeIndex, setActiveIndex] = useState(0);
  const [ratingKey, setRatingKey] = useState(0);
  const [bookingDate, setBookingDate] = useState(null);
  const [tableKey, setTableKey] = useState(0);
  const [translations, setTranslations] = useState({
    tutorIntroductionLabel: "",
    tutorReviewLabel: "",
    makeAReservationButton: "",
    trainerErrorMessage: "",
    trainerRatingsErrorMessage: "",
    experienceLabel: "",
    yearOfExperienceLabel: "",
    teachingStyleLabel: "",
    unknownLabel: "",
    certificationLabel: "",
    videoIsUnavailableMessage: "",
    tutorScheduleLabel: "",
    datetimeLabel: "",
    remainingSlotLabel: "",
    tuitionFeeLabel: "",
    tutorIntroductionTitleLabel: "",
    tutorIntroductionTitleContentLabel: "",
    lectureStyleContentLabel: "",
    successLabel: "",
    ratingSuccessMessage: "",
    availableLabel: "",
    unavailableLabel: "",
    confirmBookingHeader: "",
    successfullyBookingMessage: "",
    errorBookingMessage: "",
    cancelLabel: "",
    confirmBookingLabel: "",
    personalTrainerLabel: "",
    sessionDetailsLabel: "",
    sessionDuration: "",
    time: "",
    tickets: "",
    ACTIVE: "",
    CALM: "",
    SERIOUS: "",
    INQUISITIVE: "",
    CONCISE: "",
    ANNOUNCER: "",
    RAPPER: "",
    GAG: "",
    ACTION: "",
    BASS: "",
    NORMAL: "",
    HIGH: "",
    TEXTBOOKS: "",
    NATIONALITY: "",
    BEGINNER: "",
    INTERMEDIATE: "",
    ADVANCED: "",
    K_CULTURE: "",
    K_BEAUTY: "",
    LIT: "",
    PROVERB: "",
    KOREAN_CUISINE: "",
    DAILY_CONVO: "",
    DAILY_NEWS: "",
    BOARD_GAMES: "",
    FREE_TOPICS: "",
    BUSINESS: "",
    SCHOOL_LIFE: "",
    STUDENTS: "",
    ADULTS: "",
    TOPIK: "",
    BACHELOR: "",
    MASTER: "",
    PHD: "",
    Monday: "",
    Tuesday: "",
    Wednesday: "",
    Thursday: "",
    Friday: "",
    Saturday: "",
    Sunday: "",
  });
  const ratingToast = useRef(null);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 992);

  const loadTranslations = async () => {
    const tutorIntroductionLabel = await translate("TRAINERS.LABELS.TUTOR_INTRODUCTION");
    const makeAReservationButton = await translate("TRAINERS.BUTTONS.MAKE_A_RESERVATION");
    const trainerErrorMessage = await translate("API_MESSAGES.EXCEPTIONS.FAIL_TO_GET_TRAINER_INFORMATION");
    const trainerRatingsErrorMessage = await translate("API_MESSAGES.EXCEPTIONS.FAIL_TO_GET_TRAINER_RATINGS");
    const experienceLabel = await translate("TRAINERS.LABELS.EXPERIENCE");
    const yearOfExperienceLabel = await translate("TRAINERS.LABELS.YEAR_OF_EXPERIENCE");
    const teachingStyleLabel = await translate("TRAINERS.LABELS.TEACHING_STYLE");
    const unknownLabel = await translate("TRAINERS.LABELS.UNKNOWN");
    const certificationLabel = await translate("TRAINERS.LABELS.CERTIFICATIONS");
    const videoIsUnavailableMessage = await translate("TRAINERS.LABELS.TUTOR_INTRODUCTION");
    const tutorReviewLabel = await translate("TRAINERS.LABELS.TUTOR_REVIEWS");
    const tutorScheduleLabel = await translate("TRAINERS.LABELS.TUTOR_SCHEDULE");
    const datetimeLabel = await translate("TRAINERS.LABELS.DATETIME");
    const remainingSlotLabel = await translate("TRAINERS.LABELS.REMAINING_SLOT");
    const tuitionFeeLabel = await translate("TRAINERS.LABELS.TUITION_FEE");
    const tutorIntroductionTitleLabel = await translate("TRAINERS.LABELS.TUTOR_INTRODUCTION_TITLE");
    const tutorIntroductionTitleContentLabel = await translate("TRAINERS.LABELS.TUTOR_INTRODUCTION_CONTENT");
    const lectureStyleContentLabel = await translate("TRAINERS.LABELS.LECTURE_STYLE_CONTENT");
    const successLabel = await translate("TRAINERS.MESSAGES.SUCCESS");
    const ratingSuccessMessage = await translate("TRAINERS.MESSAGES.RATING_SUCCESS");
    const availableLabel = await translate("TRAINERS.LABELS.AVAILABLE_LABEL");
    const unavailableLabel = await translate("TRAINERS.LABELS.UNAVAILABLE_LABEL");
    const confirmBookingHeader = await translate("TRAINERS.LABELS.CONFIRM_BOOKING_HEADER");
    const successfullyBookingMessage = await translate("TRAINERS.API_MESSAGE.SUCCESSFULLY_BOOKING_MESSAGE");
    const errorBookingMessage = await translate("TRAINERS.API_MESSAGE.ERROR_BOOKING_MESSAGE");
    const cancelLabel = await translate("TRAINERS.LABELS.CANCEL_LABEL");
    const confirmBookingLabel = await translate("TRAINERS.LABELS.CONFIRM_BOOKING_LABEL");
    const personalTrainerLabel = await translate("TRAINERS.LABELS.PERSONAL_TRAINER_LABEL");
    const sessionDetailsLabel = await translate("TRAINERS.LABELS.SESSION_DETAILS_LABEL");
    const sessionDuration = await translate("TRAINERS.LABELS.SESSION_DURATION");
    const time = await translate("TRAINERS.LABELS.TIME");
    const tickets = await translate("TRAINERS.LABELS.TICKETS");
    const ACTIVE = await translate("common_ns:COMMON_ITEMS.PERSONALITY.ACTIVE");
    const CALM = await translate("common_ns:COMMON_ITEMS.PERSONALITY.CALM");
    const SERIOUS = await translate("common_ns:COMMON_ITEMS.PERSONALITY.SERIOUS");
    const INQUISITIVE = await translate("common_ns:COMMON_ITEMS.COMMUNICATION_STYLE.INQUISITIVE");
    const CONCISE = await translate("common_ns:COMMON_ITEMS.COMMUNICATION_STYLE.CONCISE");
    const ANNOUNCER = await translate("common_ns:COMMON_ITEMS.TEACHING_STYLE.ANNOUNCER");
    const RAPPER = await translate("common_ns:COMMON_ITEMS.TEACHING_STYLE.RAPPER");
    const GAG = await translate("common_ns:COMMON_ITEMS.TEACHING_STYLE.GAG");
    const ACTION = await translate("common_ns:COMMON_ITEMS.TEACHING_STYLE.ACTION");
    const BASS = await translate("common_ns:COMMON_ITEMS.VOICE_TONE_LEVEL.BASS");
    const NORMAL = await translate("common_ns:COMMON_ITEMS.VOICE_TONE_LEVEL.NORMAL");
    const HIGH = await translate("common_ns:COMMON_ITEMS.VOICE_TONE_LEVEL.HIGH");
    const TEXTBOOKS = await translate("common_ns:COMMON_ITEMS.EDUCATION.TEXTBOOKS");
    const NATIONALITY = await translate("common_ns:COMMON_ITEMS.EDUCATION.NATIONALITY");
    const BEGINNER = await translate("common_ns:COMMON_ITEMS.EDUCATION.BEGINNER");
    const INTERMEDIATE = await translate("common_ns:COMMON_ITEMS.EDUCATION.INTERMEDIATE");
    const ADVANCED = await translate("common_ns:COMMON_ITEMS.EDUCATION.ADVANCED");
    const K_CULTURE = await translate("common_ns:COMMON_ITEMS.CULTURE.K_CULTURE");
    const K_BEAUTY = await translate("common_ns:COMMON_ITEMS.CULTURE.K_BEAUTY");
    const LIT = await translate("common_ns:COMMON_ITEMS.CULTURE.LIT");
    const PROVERB = await translate("common_ns:COMMON_ITEMS.CULTURE.PROVERB");
    const KOREAN_CUISINE = await translate("common_ns:COMMON_ITEMS.CULTURE.KOREAN_CUISINE");
    const DAILY_CONVO = await translate("common_ns:COMMON_ITEMS.LIFE.DAILY_CONVO");
    const DAILY_NEWS = await translate("common_ns:COMMON_ITEMS.LIFE.DAILY_NEWS");
    const BOARD_GAMES = await translate("common_ns:COMMON_ITEMS.LIFE.BOARD_GAMES");
    const FREE_TOPICS = await translate("common_ns:COMMON_ITEMS.LIFE.FREE_TOPICS");
    const BUSINESS = await translate("common_ns:COMMON_ITEMS.LIFE.BUSINESS");
    const SCHOOL_LIFE = await translate("common_ns:COMMON_ITEMS.LIFE.SCHOOL_LIFE");
    const STUDENTS = await translate("common_ns:COMMON_ITEMS.TARGET.STUDENTS");
    const ADULTS = await translate("common_ns:COMMON_ITEMS.TARGET.ADULTS");
    const TOPIK = await translate("common_ns:COMMON_ITEMS.EDUCATION.TOPIK");
    const BACHELOR = await translate("common_ns:COMMON_ITEMS.HIGHEST_LEVEL_OF_EDUCATION.BACHELOR");
    const MASTER = await translate("common_ns:COMMON_ITEMS.HIGHEST_LEVEL_OF_EDUCATION.MASTER");
    const PHD = await translate("common_ns:COMMON_ITEMS.HIGHEST_LEVEL_OF_EDUCATION.PHD");
    const Monday = await translate("common_ns:LABELS.WEEKDAY.MONDAY");
    const Tuesday = await translate("common_ns:LABELS.WEEKDAY.TUESDAY");
    const Wednesday = await translate("common_ns:LABELS.WEEKDAY.WEDNESDAY");
    const Thursday = await translate("common_ns:LABELS.WEEKDAY.THURSDAY");
    const Friday = await translate("common_ns:LABELS.WEEKDAY.FRIDAY");
    const Saturday = await translate("common_ns:LABELS.WEEKDAY.SATURDAY");
    const Sunday = await translate("common_ns:LABELS.WEEKDAY.SUNDAY");
    setTranslations({
      tutorIntroductionLabel,
      tutorReviewLabel,
      makeAReservationButton,
      trainerErrorMessage,
      trainerRatingsErrorMessage,
      experienceLabel,
      yearOfExperienceLabel,
      teachingStyleLabel,
      unknownLabel,
      certificationLabel,
      videoIsUnavailableMessage,
      tutorScheduleLabel,
      datetimeLabel,
      remainingSlotLabel,
      tuitionFeeLabel,
      tutorIntroductionTitleLabel,
      tutorIntroductionTitleContentLabel,
      lectureStyleContentLabel,
      successLabel,
      ratingSuccessMessage,
      availableLabel,
      unavailableLabel,
      confirmBookingHeader,
      successfullyBookingMessage,
      errorBookingMessage,
      cancelLabel,
      confirmBookingLabel,
      personalTrainerLabel,
      sessionDetailsLabel,
      sessionDuration,
      time,
      tickets,
      ACTIVE,
      CALM,
      SERIOUS,
      INQUISITIVE,
      CONCISE,
      ANNOUNCER,
      RAPPER,
      GAG,
      ACTION,
      BASS,
      NORMAL,
      HIGH,
      TEXTBOOKS,
      NATIONALITY,
      BEGINNER,
      INTERMEDIATE,
      ADVANCED,
      K_CULTURE,
      K_BEAUTY,
      LIT,
      PROVERB,
      KOREAN_CUISINE,
      DAILY_CONVO,
      DAILY_NEWS,
      BOARD_GAMES,
      FREE_TOPICS,
      BUSINESS,
      SCHOOL_LIFE,
      STUDENTS,
      ADULTS,
      TOPIK,
      BACHELOR,
      MASTER,
      PHD,
      Monday,
      Tuesday,
      Wednesday,
      Thursday,
      Friday,
      Saturday,
      Sunday
    });
  };

  const handleRefresh = () => {
    setBookingDate(null);
    setTableKey(prevKey => prevKey + 1); // Changing key forces remount
  };

  const handleHide = () => {
    setVisible(false);
  }

  const handleRatingSuccess = (updatedTotalRating, updatedAverageRating) => {
    ratingToast.current.show({ 
      severity: 'success', 
      summary: translations.successLabel, 
      detail: translations.ratingSuccessMessage, 
      life: 3000,
      content: (props) => SuccessTemplate(props) 
    });
    
    // Update trainer data with new rating information
    if (updatedTotalRating && trainer) {
      setTrainer(prev => ({
        ...prev,
        totalReview: updatedTotalRating,
        averageRating: updatedAverageRating || prev.averageRating,
        numberRating: updatedTotalRating
      }));
    }
    
    setVisible(false);
    setRatingKey(prev => prev + 1);
  };

  useImperativeHandle(ref, () => ({
    open: (trainerId) => {
      setVisible(true);
      setTrainerId(trainerId);
      handleRefresh();
    },
    close: () => setVisible(false)
  }));

  // Update trainer. Always keep `trainer` an object (never undefined) and swallow API
  // failures here — otherwise a missing/partial payload makes a child crash on render and,
  // with no error boundary above the embedded root, the whole tutor section disappears.
  useEffect(() => {
    if (!trainerId) return;
    getTrainerDetail(trainerId)
      .then(response => setTrainer(response?.data ?? {}))
      .catch(() => setTrainer({}));
  }, [trainerId, tableKey]);

  // Update translation
  useEffect(() => {
    const language = getI18nLanguageFromLocalStorage();
    setLanguage(language);
    loadTranslations();
  }, [lang]);

  useEffect(() => {
    const handleResize = () => setIsSmallScreen(window.innerWidth < 992);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const tabPanels = [
    {
      header: translations.tutorIntroductionLabel,
      content: <TrainerDetailInformation trainer={trainer} translations={translations} />
    },
    {
      header: translations.tutorReviewLabel,
      content: (
        <TrainerRating
          props={{ totalRating: trainer.totalReview, trainerId: trainer.id }}
          onRatingSuccess={handleRatingSuccess}
        />
      )
    },
    {
      header: translations.tutorScheduleLabel,
      content: (
        <AvailabilityTable
          key={tableKey}
          trainerPublicId={trainer.publicId}
          translations={translations}
          lang={lang}
          setBookingDate={setBookingDate}
        />
      )
    }
  ];

  return (
    <div>
      {/* TODO: Remove after ticket handle toast in master layout using state management */}
      <Toast ref={ratingToast} position="bottom-right" className="keduall-toast"/>
      <Dialog blockScroll={true} baseZIndex="10001" visible={visible} onHide={handleHide} draggable={false} resizable={false} className='trainer-detail-modal keduall-tab-panel w-11 xl:w-9' footer={<div></div>}>
        <div className='trainer-detail-modal-container grid'>
          <div className='col-12 lg:col-4'>
            <TrainerDetailProfile
              key={tableKey}
              trainer={trainer}
              translations={translations}
              lang={lang}
              defaultAvatar={defaultAvatar}
              bookingDate={bookingDate}
              handleRefresh={handleRefresh}
            />
          </div>
          <div className='col-12 lg:col-8'>
            {isSmallScreen ? (
              // Render a separate TabView for each TabPanel
              tabPanels.map((tab, index) => (
                <div key={index} className='mb-3'>
                  <TabView activeIndex={0}>
                    <TabPanel header={tab.header}>
                      <div className='fade-in'>{tab.content}</div>
                    </TabPanel>
                  </TabView>
                </div>
              ))
            ) : (
              // Render a single TabView with multiple panels on larger screens
              <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                {tabPanels.map((tab, index) => (
                  <TabPanel key={index} header={tab.header}>
                    <div className={`tab-content ${activeIndex === index ? 'fade-in' : 'fade-out'}`}>
                      {tab.content}
                    </div>
                  </TabPanel>
                ))}
              </TabView>
            )}
          </div>
        </div>
      </Dialog>
    </div>
  );
});

export default TrainerDetailModal;